__webpack_require__.p = "##NABX_EDGE_WEB_SHELL_FRONTEND_SHELL_BASE_PATH##";